module.exports = __webpack_public_path__ + "assets/media/day15.85c7697c.mp3";